module.exports = __webpack_public_path__ + "img/3.28da7830.jpg";